module.exports = __webpack_public_path__ + "img/Header-Logo.8be8d959.png";